import authService from '@/api/authService';
import { Button, Stack, Text, Title } from '@mantine/core';
import { IconBarrierBlock } from '@tabler/icons-react';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { useTranslator } from 'translations';
import z from 'zod';

const SearchSchema = z.object({
    redirect: z.string().optional(),
});

export const Route = createFileRoute('/maintenance')({
    component: RouteComponent,
    validateSearch: SearchSchema,
    async beforeLoad({ search }) {
        const login = await authService.requireLogin(search.redirect);

        if (!login.maintenance?.enabled || login.maintenanceExempt) {
            throw redirect({
                to: search.redirect ?? '/',
                search: {
                    redirect: undefined,
                },
            });
        }
    },
});

function RouteComponent() {
    const t = useTranslator();
    const router = useRouter();
    const [appLogin] = authService.appLogin.useCache();
    const maintenance = appLogin?.maintenance;

    async function retry() {
        await authService.appLogin.get({ update: 'force' });
        await router.invalidate();
    }

    return (
        <Stack
            align="center"
            justify="center"
            gap="md"
            css={{
                minHeight: '100dvh',
                padding: 'var(--mantine-spacing-md)',
            }}
        >
            <IconBarrierBlock size={64} color="var(--mantine-color-orange-6)" />

            <Title order={2}>{t('maintenance.title')}</Title>

            <Text
                c="dimmed"
                ta="center"
                css={{
                    maxWidth: 480,
                    whiteSpace: 'pre-wrap',
                }}
            >
                {maintenance?.message ||
                    t(
                        maintenance?.startup
                            ? 'maintenance.startupDescription'
                            : 'maintenance.description',
                    )}
            </Text>

            <Button variant="light" onClick={retry}>
                {t('retry')}
            </Button>
        </Stack>
    );
}
